import React from 'react';
import Lottie from 'react-lottie';
import loadingAnimation from '../../assets/loading-spinner.json';
import loadingBlue from '../../assets/lottieFiles/loading-blue.json';
import successAnimation from '../../assets/loading-check.json';
import style from './LoadingButton.module.css';

const loadingAnimationOptions = (blueSpinner) => ({
  animationData: blueSpinner ? loadingBlue : loadingAnimation,
  autoplay: true,
  loop: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
});

const successAnimationOptions = {
  animationData: successAnimation,
  autoplay: true,
  loop: false,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const LoadingButton = ({
  className = '',
  disabled = false,
  height = 20,
  id,
  loading = false,
  blueSpinner = false,
  onClick = () => { },
  onSuccessAnimationEnd = () => { },
  submit = true,
  success = false,
  icon = null,
  text = '',
  textStyle = '',
  width = 20,
  ...rest
}) => {
  function handleAnimationEnd() {
    if (onSuccessAnimationEnd) {
      onSuccessAnimationEnd();
    }
  }

  function renderButtonContent() {
    if (loading) {
      return (
        <Lottie
          height={height}
          isClickToPauseDisabled
          options={loadingAnimationOptions(blueSpinner)}
          width={width}
        />
      );
    }

    if (!loading && success) {
      return (
        <Lottie
          eventListeners={[{
            callback: handleAnimationEnd,
            eventName: 'complete',
          }]}
          height={height}
          isClickToPauseDisabled
          options={successAnimationOptions}
          width={width}
        />
      );
    }

    return (
      <div className={style.loadingTextAndIconContainer}>
        {icon && <img alt="" src={icon} />}

        <span className={`${style.loadingButtonText} ${textStyle}`}>
          {text}
        </span>
      </div>
    );
  }

  function handleOnClick(event) {
    if (onClick && !loading && !success) {
      onClick(event);
    }
  }

  return (
    <button
      className={`${style.loadingButtonContainer} ${className}`}
      disabled={disabled}
      id={id}
      onClick={handleOnClick}
      type={submit ? 'submit' : 'button'}
      {...rest}
    >
      {renderButtonContent()}
    </button>
  );
};

export default LoadingButton;
